import Vue from "vue"

export class MainMargins {
	private data: {top: number, bottom: number}

	public get top(): number {
		return this.data.top
	}
	public set top(value: number) {
		this.data.top = value
	}

	public get bottom(): number {
		return this.data.bottom
	}
	public set bottom(value: number) {
		this.data.bottom = value
	}

	constructor() {
		this.data = Vue.observable({top: 0, bottom: 0})
	}
}

export default new MainMargins()
